<template>
  <div>
    <common-header title="My Creatives" :breadcrumbs="breadcrumbs" divided>
      <template #btn>
        <el-col style="width: 65px" v-show="selections.length">
          <el-button
            class="btn btn-default btn-outline-blue"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.CLONE,
                row: {
                  name: 'Creatives',
                  item: selections,
                },
              })
            "
          >
            <i class="fas fa-copy"></i>
          </el-button>
        </el-col>
        <el-col style="width: 65px" v-show="selections.length">
          <el-button
            class="btn btn-default btn-outline-blue"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.DELETE,
                row: {
                  item: CONSTANT.DIALOG_TYPE.CREATIVE,
                  name: 'All',
                },
              })
            "
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </el-col>
        <el-col style="width: 65px" v-show="selections.length">
          <el-button
            class="btn btn-default btn-outline-blue"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.SELECT_FOLDER,
                row: {
                  folder: folderId,
                },
              })
            "
          >
            <i class="fas fa-folder-open"></i>
          </el-button>
        </el-col>
        <el-col style="width: 65px" v-show="selections.length">
          <el-button 
            class="btn btn-default btn-outline-blue"
            @click="showDialog({ 
              type: CONSTANT.DIALOG_TYPE.SELECT_CREATIVE_TAG_TYPE,
              row: {
                selections: selections,
              },
            })"
          >
          <i class="fas fa-file-download"></i>
          </el-button>
        </el-col>
        <el-col style="width: 65px" v-show="!folderId">
          <el-button
            class="btn btn-default btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="showDialog({ type: CONSTANT.DIALOG_TYPE.CREATIVE_FOLDER })"
          >
            <i class="fas fa-folder-plus"></i>
          </el-button>
        </el-col>
        <el-col style="width: 65px">
          <el-button
            class="btn btn-default btn-outline-pink"
            v-if="
              CONSTANT.USER_LEVEL_FILTER.MID.includes(
                userInfo.service.user_level
              )
            "
            @click="
              showDialog({
                type: CONSTANT.DIALOG_TYPE.SELECT_CREATIVE_TYPE,
                row: {
                  folder: folderId,
                  advertiser: filter.advertiser,
                  campaign: filter.campaign,
                },
              })
            "
          >
            <i class="fas fa-palette"></i>
          </el-button>
        </el-col>
      </template>
      <el-row type="flex">
        <el-form label-width="80px" inline>
          <el-form-item label="Advertiser" prop="advertiser">
            <el-select
              v-model="filter.advertiser"
              @change="filter.campaign = null"
              clearable
            >
              <el-option
                v-for="opt in advertiserOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Campaign" prop="campaign">
            <el-select
              v-model="filter.campaign"
              clearable
              :disabled="!filter.advertiser"
            >
              <el-option
                v-for="opt in campaignOptions"
                :key="opt.value"
                :label="opt.label"
                :value="opt.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-row>
    </common-header>
    <creative-folder
      style="padding-bottom: 40px"
      v-if="!folderId && !filter.advertiser"
    ></creative-folder>
    <creative-table :filter="filter"></creative-table>
    <dialogs></dialogs>
    <context-menus></context-menus>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import JsonCSV from 'vue-json-csv';
import CommonHeader from '@/components/base/header';
import CreativeFolder from '@/components/pages/creatives/folder';
import CreativeTable from '@/components/pages/creatives/table';
import Dialogs from '@/components/common/dialogs/index';
import ContextMenus from '@/components/common/contextMenus/index';
import MixFunc from '@/components/mixins/base.js';
export default {
  data() {
    return {
      folderId: this.$route.params.folderId,
      breadcrumbs: null,
      filter: {
        advertiser: this.$route.query.advertiser,
        campaign: this.$route.query.campaign,
      },
    };
  },
  components: {
    DownloadCsv: JsonCSV,
    CommonHeader,
    CreativeFolder,
    CreativeTable,
    Dialogs,
    ContextMenus,
  },
  mixins: [MixFunc],
  computed: {
    ...mapState({
      creatives: (state) => state.creative.creatives,
      selections: (state) => state.creative.selections,
      folders: (state) => state.creativeFolder.folders,
      audiences: (state) => state.audience.audiences,
      advertisers: (state) => state.advertiser.advertisers,
      assets: (state) => state.asset.assets,
      userInfo: (state) => state.user.userInfo,
      advertiserOptions: (state) =>
        _.map(state.advertiser.advertisers, (i) => ({
          label: i.name,
          value: i._id,
          campaigns: i.campaigns,
        })),
    }),
    campaignOptions() {
      if (!this.filter.advertiser) {
        return [];
      }
      const advertiser = _.find(
        this.advertiserOptions,
        (advertiser) => advertiser.value === this.filter.advertiser
      );
      if (!advertiser) return [];
      return _.map(advertiser.campaigns, (i) => ({
        label: i.name,
        value: i._id,
      }));
    },
  },
  async created() {
    let req_list = [];
    if (!this.creatives.length) {
      req_list.push(store.dispatch('creative/getCreatives'));
    }
    if (!this.folders.length) {
      req_list.push(store.dispatch('creativeFolder/getCreativeFolders'));
    }
    if (!this.audiences.length) {
      req_list.push(store.dispatch('audience/getAudiences'));
    }
    if (!this.advertisers.length) {
      req_list.push(store.dispatch('advertiser/getAdvertisers'));
    }
    if (!this.assets.length) {
      req_list.push(store.dispatch('asset/getAssets'));
    }
    await Promise.all(req_list);

    if (this.folderId) {
      let currentItem = _.find(
        this.folders,
        (item) => item._id === this.folderId
      );

      let routers = this.setHeaderRouter([], currentItem._id);
      let currentPath = { name: currentItem.name };
      let sameLayerPath = _.filter(
        this.folders,
        (item) =>
          currentItem._id != item._id &&
          ((!currentItem.hasOwnProperty('parentFolder') &&
            !item.hasOwnProperty('parentFolder')) ||
            currentItem.parentFolder == item.parentFolder)
      ).map((item) => ({ name: item.name, path: `/folder/${item._id}` }));

      this.breadcrumbs = { routers, currentPath, sameLayerPath };
    }
  },
  methods: {
    ...mapActions({
      showDialog: 'showDialog',
    }),
    setHeaderRouter(array, id) {
      let item = _.find(this.folders, (item) => item._id === id);
      if (!item.hasOwnProperty('parentFolder')) {
        array.push({ name: 'My Creatives', path: '/creatives' });
      } else {
        this.setHeaderRouter(array, item.parentFolder);
        array.push({ name: item.name, path: `/folder/${item._id}` });
      }
      return array;
    },
  },
};
</script>

<style></style>
